import { defineComponent as m, computed as d, useCssModule as p, openBlock as c, createBlock as f, unref as l, withCtx as w, createElementVNode as v, normalizeClass as b } from "vue";
import h from "../VBaseModal/VBaseModal.vue.mjs";
const k = /* @__PURE__ */ m({
  __name: "VNewVersion",
  props: {
    isModalShow: { type: Boolean }
  },
  emits: ["update:is-modal-show", "cancel", "submit"],
  setup(a, { emit: r }) {
    const i = a, o = r, t = d({
      get() {
        return i.isModalShow;
      },
      set(n) {
        o("update:is-modal-show", n);
      }
    }), u = p();
    return (n, e) => (c(), f(l(h), {
      "is-modal-show": t.value,
      "onUpdate:isModalShow": e[0] || (e[0] = (s) => t.value = s),
      title: "New version available",
      "submit-button-text": "Refresh",
      "close-on-overlay-click": !1,
      onCancel: e[1] || (e[1] = (s) => o("cancel")),
      onSubmit: e[2] || (e[2] = (s) => o("submit")),
      onClose: e[3] || (e[3] = (s) => o("cancel"))
    }, {
      default: w(() => [
        v("p", {
          class: b(l(u)["v-new-version__content"])
        }, ' Please click "Refresh" to use the latest version of Vsimple! If you need to save your work first, hit "Cancel" and refresh your browser at your convenience. ', 2)
      ]),
      _: 1
    }, 8, ["is-modal-show"]));
  }
});
export {
  k as default
};
